import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { bemGenerator } from '@prisjakt/ui-base';
import { AppContext } from '@prisjakt/ui-app-context';
import alertActions from '../../../sidebar/actions/alert';

import './index.scss';

const styles = bemGenerator('pre-release-information', ['badge']);

class PreReleaseInformation extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isActiveAlert: false,
    };
  }

  render() {
    const { props, context, history } = this;
    const { t, linkTo } = context;
    const {
      product,
      releaseDate,
      account,
      listAlert,
      createAlertRequest,
    } = props;
    const loggedIn = !!account.me;
    const { createdAlerts, deletedAlerts } = listAlert;
    let { alertId } = product;
    if (deletedAlerts[alertId]) {
      alertId = null;
    }
    if (createdAlerts[product.id]) {
      alertId = createdAlerts[product.id];
    }
    if (alertId) {
      this.state.isActiveAlert = true;
    }

    return (
      <div className={styles.block}>
        <button
          type="button"
          className={styles.badge.withModifier({
            'active-alert': this.state.isActiveAlert,
          })}
          aria-label={t('product', 'alert.create-button')}
          onClick={() => {
            if (loggedIn) {
              if (!alertId) {
                createAlertRequest({
                  productId: product.id,
                  type: 'IN_STOCK',
                });
              }
            } else {
              history.push(linkTo('productAlert', product));
            }
          }}
        >
          <div>
            <h2>{t('product', 'pre-release.new-release')}</h2>
            <small>{t('product', 'pre-release.comming-soon')}</small>
          </div>
          <button type="button">
            {t('product', 'pre-release.stock-alert-button')}
          </button>
        </button>
        <p>
          {releaseDate &&
            t('product', 'pre-release.model-information', {
              productName: product.name,
              releaseDate,
            })}
        </p>
      </div>
    );
  }
}

const { string, shape, number, object, func } = PropTypes;

PreReleaseInformation.propTypes = {
  account: shape({ me: object }),
  listAlert: shape({
    createdAlerts: object, // eslint-disable-line react/forbid-prop-types
    deletedAlerts: object, // eslint-disable-line react/forbid-prop-types
  }),
  product: shape({
    alertId: number,
    id: number,
    name: string,
    pathName: string,
  }),
  releaseDate: string,
  createAlertRequest: func.isRequired,
  history: object.isRequired,
};

PreReleaseInformation.defaultProps = {
  account: { me: undefined },
  listAlert: {
    createdAlerts: {},
    deletedAlerts: {},
  },
  product: {},
  releaseDate: undefined,
};

PreReleaseInformation.contextType = AppContext;

export default connect(
  state => ({
    account: state.areas.account,
    listAlert: state.areas.sidebar,
  }),
  { ...alertActions }
)(withRouter(PreReleaseInformation));
